module.exports = __webpack_public_path__ + "static/media/ic-player-countdown-play.f3be16c6.svg";